import { InnerBox } from "@/components/elements/InnerBox";
import { TextWithLinks } from "@/components/commons/TextWithLinks";
import { EMPTY_STR } from "@/constants/string";
import { TalentInfoItem } from "@/features/talent/components/talent-detail/TalentInfoItem";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider, black, text } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Stack, Box, Typography, Grid } from "@mui/material";

type TTalentDesiredConditionProps = {
  defaultValues?: Partial<TTalentForm>;
};

export const TalentDesiredCondition: FCC<TTalentDesiredConditionProps> = ({ defaultValues }) => {
  return (
    <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box flex={1}>
          <Typography variant="sub16Bold" color={black[30]}>
            希望条件
          </Typography>
        </Box>
      </Stack>

      <Stack mt={3}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TalentInfoItem
              label="希望職種（分野）"
              value={
                defaultValues?.desiredJobTypes && defaultValues.desiredJobTypes.length > 0
                  ? defaultValues.desiredJobTypes
                      .map((item) => item.companySpecificIndustry)
                      .filter(Boolean)
                      .join("、")
                  : EMPTY_STR.TEXT
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TalentInfoItem label="希望勤務地" value={defaultValues?.desiredWorkLocation ?? EMPTY_STR.TEXT} />
          </Grid>

          <Grid item xs={12}>
            <TalentInfoItem label="希望給与" value={defaultValues?.expectSalary ?? EMPTY_STR.TEXT} />
          </Grid>
          <Grid item xs={12}>
            <TalentInfoItem label="転職可能時期" value={defaultValues?.availableFrom ?? EMPTY_STR.TEXT} />
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="cap12" color={black[70]}>
                その他希望
              </Typography>
            </Box>

            <Box
              mt={0.5}
              component="pre"
              sx={{
                fontFamily: "inherit",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {defaultValues?.otherRequest ? (
                <Typography variant="body14Semi" color={text.primary} component="span">
                  <TextWithLinks text={defaultValues.otherRequest!} />
                </Typography>
              ) : (
                EMPTY_STR.TEXT
              )}
            </Box>
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
